(function () {
    'use strict';

    angular
        .module('portalApp')
        .provider('chartConfig', chartConfig);

    // configuration
    chartConfig.$inject = ['chartConstants'];

    function chartConfig(chartConstants) {
        this.timeseriesChartDefaultDateFormat = 'YYFP';
        this.timeseriesChartDefaultFrequency = 4; //quarterly
        this.timeseriesChartDefaultShadowStyle = {
            color: '#aea',
            opacity: 0.25
        };
        this.timeseriesChartDefaultObject = {
            height: 250,
            xAxis: {
                font: {
                    size: "12px",
                    fontFamily: "Helvetica",
                    color: "#1e2834"
                },
                show: true, // to be changed for empty charts
                grid: true,
                scale: 'category',
                shading: [] //range shadowing is empty by default
            },
            yAxis: {
                font: {
                    size: "12px",
                    fontFamily: "Helvetica",
                    color: "#1e2834"
                },
                title: {
                    show: false,
                    text: 'Yield (%, annually compounded)',
                    font: {
                        size: "12px",
                        fontFamily: "Helvetica",
                        color: "#1e2834"
                    }
                },
                show: true, // to be changed for empty charts
                grid: true
            },
            seriesStyle: {
                defaultOpacity: 0.75,
                hoverOpacity: 1
            },
            //Series are to be filled in the app
            series: [],
            //vertical tracker line with a tooltip per series
            tracker: true,
            legend: {
                show: true,
                font: {
                    size: "12px",
                    fontFamily: "Helvetica",
                    color: "#1e2834"
                },
                clickToHide: false
            },
            placeholder: {
                show: false, // to be changed for empty charts
                text: "Empty",
                fontSize: "24px",
                opacity: 0.2
            },
            tooltipText: tooltipText
        };

        this.timeseriesChartDefaultLineStyles = {
            predefined: [ //todo: only seven lines are predefined so far, will see if more is needed
                {
                    width: 3,
                    color: chartConstants.lineColorSet[0],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[1],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[2],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[3],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[4],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[5],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[6],
                    dashSetting: [1, 0],
                    markerSize: 2
                }
            ],
            new: {
                width: 3,
                color: null, //will be picked automatically
                dashSetting: [1, 0],
                markerSize: 2
            }
        };

        this.$get = function () {
            return {
                timeseriesChartDefaults: {
                    chartObject: this.timeseriesChartDefaultObject,
                    lineStyles: this.timeseriesChartDefaultLineStyles,
                    dateFormat: this.timeseriesChartDefaultDateFormat,
                    frequency: this.timeseriesChartDefaultFrequency,
                    shadowStyle: this.timeseriesChartDefaultShadowStyle
                }
            };
        };

        function tooltipText(point) {
            if (angular.isDefined(point.lower)) {
                return "High : " + point.upper.toPrecision(4) + " <br/> " + "Low : " + point.lower.toPrecision(4);
            }
            //reformat Y number up to 4th precision point
            return point.x + " : " + point.y.toPrecision(4);
        }
    }
})();
